import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HrtApiService } from '../hrt-api/hrt-api.service';
import { Organization } from '@brc/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsApiService {
  readonly organizationsUrl = 'organizations';

  readonly api = inject(HrtApiService);

  public fetchOrganizations(): Observable<Organization[]> {
    return this.api.get<Organization[]>(this.organizationsUrl);
  }
}
